const DEFAULT_MAX_RETRIES = 4;

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// Safari ferme/réutilise parfois une connexion keep-alive obsolète, ce qui
// fait échouer un appel réseau avec "La connexion réseau a été perdue" (-1005).
// L'erreur est intermittente : un simple retry sur une nouvelle connexion passe.
// `fn` est appelée à chaque tentative et doit retourner une promesse.
export const withRetry = async (fn, maxRetries = DEFAULT_MAX_RETRIES) => {
  let lastErr;
  for (let attempt = 0; attempt <= maxRetries; attempt++) {
    try {
      return await fn();
    } catch (err) {
      lastErr = err;
      if (attempt < maxRetries) {
        await wait(300 * (attempt + 1));
      }
    }
  }
  throw lastErr;
};
